/**
 * V2 yoink management — who may edit/delete, and V1's delete cascade
 * (modals/delete-yoink.js): storage images best-effort → the row →
 * the location if orphaned → caches.
 */
import * as gateway from '../../core/gateway.js';
import { invalidate } from '../../core/query.js';

/** Owner or admin (V1: edit-yoink.js:190). */
export function canManage(store, yoink) {
  const { user, profile } = store.get();
  if (!user || !yoink) return false;
  return yoink.user_id === user.id || profile?.role === 'admin';
}

/** V1 delete-yoink.js:343 — remove the location once nothing references it. */
export async function cleanupOrphanLocation(locationId) {
  if (!locationId) return;
  const { data, error } = await gateway.rawQuery(gateway.TABLES.YOINKS, {
    select: 'id',
    filters: { location_id: `eq.${locationId}` },
    limit: 1,
  });
  if (error || (data && data.length)) return;
  await gateway.rawDelete(gateway.TABLES.LOCATIONS, {
    filters: { id: `eq.${locationId}` },
  });
}

/**
 * Delete a yoink with V1's cascade. Throws only if the row delete fails —
 * orphaned storage files are acceptable (V1 behavior).
 */
export async function deleteYoink(yoink) {
  for (const path of yoink.images || []) {
    if (path && !path.startsWith('http')) {
      try {
        await gateway.deleteFile('yoinks', path);
      } catch {
        // Orphaned files are acceptable — keep going
      }
    }
  }
  const { error } = await gateway.rawDelete(gateway.TABLES.YOINKS, {
    filters: { id: `eq.${yoink.id}` },
  });
  if (error) throw new Error(`Couldn’t delete: ${error.message}`);
  await cleanupOrphanLocation(yoink.location_id).catch(() => {});
  invalidate();
}
